export const TreatmentScheduleWithName = [
  { id: 1, name: 'Specific time', key: 'SpecificTime' },
  { id: 2, name: 'Time slot', key: 'TimeSlots' },
  { id: 3, name: 'Multiple visits per day', key: 'MultipleVisitsPerDay' },
];
